import { render, staticRenderFns } from "./CjList.vue?vue&type=template&id=b780a822&"
import script from "./CjList.vue?vue&type=script&lang=js&"
export * from "./CjList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports